import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Alert, Spinner } from '@cloudscape-design/components';
import { apiFetch } from '../../auth/apiClient';
import { appealWorkspacePath } from '../../utils/appealWorkspace';

// Retain old bookmarks/notification links, but review in the owning workspace.
export default function AppealsEntry() {
  const { caseId } = useParams();
  const location = useLocation();
  const history = useHistory();
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    const params = new URLSearchParams(location.search);
    const id = params.get('appeal');
    if (!id) {
      history.replace(`/cases/${caseId}?appeal=${params.has('new') ? 'new' : 'list'}`);
      return undefined;
    }
    apiFetch(`/api/appeals/${id}`).then(async response => {
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'The appeal could not be loaded.');
      if (String(data.appeal?.caseId) !== String(caseId)) throw new Error('This appeal belongs to a different case.');
      if (active) history.replace(appealWorkspacePath(data.appeal));
    }).catch(e => { if (active) setError(e.message); });
    return () => { active = false; };
  }, [caseId, location.search, history]);
  return error ? <Alert type="error">{error}</Alert> : <Spinner />;
}
